import { mapToCanActivate, Routes } from '@angular/router';
import { AuthGuard } from '@next/core-lib/authorization';

import { CustomerDetailComponent } from './components/customer-detail/customer-detail.component';
import { CustomerItemComponent } from './components/customer-item/customer-item.component';
import { CustomerOverviewComponent } from './components/customer-overview/customer-overview.component';
import { CustomerLocationDetailComponent } from './components/locations/customer-location-detail/customer-location-detail.component';
import { CustomerLocationsComponent } from './components/locations/customer-locations/customer-locations.component';
import { CustomerComponent } from './customer.component';
import { CustomersGuard } from './guards/customers.guard';

const routes: Routes = [
  {
    path: '',
    component: CustomerOverviewComponent,
    canActivate: mapToCanActivate([CustomersGuard]),
    data: { name: 'customer-overview', pageTitle: 'app.customer.module' },
  },
  {
    path: ':customerId/location/:locationId',
    component: CustomerLocationDetailComponent,
    canActivate: mapToCanActivate([CustomersGuard]),
    data: { name: 'customer-location-detail' },
  },
  {
    path: ':customerId',
    component: CustomerItemComponent,
    canActivate: mapToCanActivate([CustomersGuard]),
    children: [
      {
        path: '',
        component: CustomerDetailComponent,
        data: { name: 'customer-detail' },
      },
      {
        path: 'location',
        component: CustomerLocationsComponent,
        data: { name: 'customer-locations' },
      },
    ],
  },
];

export const customerRoutes: Routes = [
  { path: '', redirectTo: 'customer', pathMatch: 'full' },
  {
    path: 'customer',
    component: CustomerComponent,
    canActivate: mapToCanActivate([AuthGuard]),
    children: routes,
  },
];
